import { render, staticRenderFns } from "./ViewDiagnose.vue?vue&type=template&id=68992f6a&scoped=true"
import script from "./ViewDiagnose.vue?vue&type=script&lang=js"
export * from "./ViewDiagnose.vue?vue&type=script&lang=js"
import style0 from "./ViewDiagnose.vue?vue&type=style&index=0&id=68992f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68992f6a",
  null
  
)

export default component.exports